var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("v-toolbar", {
        scopedSlots: _vm._u([
          {
            key: "extension",
            fn: function() {
              return [
                _c(
                  "v-tabs",
                  {
                    model: {
                      value: _vm.tab,
                      callback: function($$v) {
                        _vm.tab = $$v
                      },
                      expression: "tab"
                    }
                  },
                  [
                    _c("v-tabs-slider", { attrs: { color: "yellow" } }),
                    _vm._v(" "),
                    _vm._l(_vm.items, function(item) {
                      return _c("v-tab", { key: item }, [
                        _vm._v("\n        " + _vm._s(item) + "\n        ")
                      ])
                    })
                  ],
                  2
                )
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _c(
        "v-tabs-items",
        {
          model: {
            value: _vm.tab,
            callback: function($$v) {
              _vm.tab = $$v
            },
            expression: "tab"
          }
        },
        _vm._l(_vm.items, function(item) {
          return _c(
            "v-tab-item",
            { key: item },
            [
              _c(
                "v-card",
                { attrs: { flat: "" } },
                [_c("v-card-text", [_vm._v(_vm._s(_vm.text))])],
                1
              )
            ],
            1
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-44e9f664", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44e9f664","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/story-edit-view/nodeEditorSidebar.vue
// module id = null
// module chunks = 